
import React from 'react';
import { 
  Plus,
  Trash2,
  Video,
  Phone,
  Building
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import DaySchedule from './DaySchedule';

export type ConsultationType = 'clinic' | 'video' | 'voice';

export interface TimeBlock {
  id: string;
  startTime: string;
  endTime: string;
  consultationTypes: ConsultationType[];
}

export interface DayScheduleType {
  isAvailable: boolean;
  timeBlocks: TimeBlock[];
}

export interface WeeklyScheduleType {
  monday: DayScheduleType;
  tuesday: DayScheduleType;
  wednesday: DayScheduleType;
  thursday: DayScheduleType;
  friday: DayScheduleType;
  saturday: DayScheduleType;
  sunday: DayScheduleType;
}

interface WeeklyScheduleProps {
  schedule: WeeklyScheduleType;
  setSchedule: React.Dispatch<React.SetStateAction<WeeklyScheduleType>>;
}

const WeeklySchedule: React.FC<WeeklyScheduleProps> = ({ schedule, setSchedule }) => {
  const days = [
    { key: 'monday', label: 'Monday' },
    { key: 'tuesday', label: 'Tuesday' },
    { key: 'wednesday', label: 'Wednesday' },
    { key: 'thursday', label: 'Thursday' },
    { key: 'friday', label: 'Friday' },
    { key: 'saturday', label: 'Saturday' },
    { key: 'sunday', label: 'Sunday' }
  ] as const;
  
  return (
    <div className="space-y-6">
      {days.map((day) => (
        <DaySchedule 
          key={day.key}
          dayName={day.label}
          dayKey={day.key}
          daySchedule={schedule[day.key]}
          setSchedule={setSchedule}
        />
      ))}
    </div>
  );
};

export default WeeklySchedule;
